import { request } from 'graphql-request';
import { gql } from 'graphql-tag';
import Config from '@annunciate/core/dist/utils/config';
export const PRODUCT_GET = gql `
  query Product ($id: ID!) {
    Product(id: $id) {
      id
      purchaseUrl
      externalIdentifiers {
        id
        identifier
        store
        purchaseUrl
        allowPurchaseWithoutAuthentication
      }
    }
  }
`;
export async function getProduct(productId) {
    const result = await request(`${Config.ENTITLEMENTS_HOST}/graphql`, PRODUCT_GET, {
        id: productId,
    });
    return result?.Product || null;
}
//# sourceMappingURL=getProduct.js.map